const LEGACY_TYPE_LABELS = {
  1: "Rent",
  2: "Kitchen",
  3: "Salary",
  4: "Other",
};

export const getExpenseTypeName = (row) => {
  if (!row) return "";
  if (row.expenseTypeId?.name) return row.expenseTypeId.name;
  if (typeof row.expenseTypeId === "object" && row.expenseTypeId?.name) {
    return row.expenseTypeId.name;
  }
  if (row.name && !row.type) return row.name;
  return LEGACY_TYPE_LABELS[Number(row.type)] || "";
};

/** @deprecated use getExpenseTypeName */
export const ConvertExpenseTypeToText = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "object") return getExpenseTypeName(value);
  return LEGACY_TYPE_LABELS[Number(value)] || "";
};

export const getExpenseTypeId = (row) => {
  if (!row) return "";
  if (row.expenseTypeId?._id) return row.expenseTypeId._id;
  if (typeof row.expenseTypeId === "string") return row.expenseTypeId;
  if (row._id && row.name && row.expense == null) return row._id;
  return "";
};

export const resolveExpenseTypeFromRow = (row, types = []) => {
  const id = getExpenseTypeId(row);
  if (id) {
    const matched = types.find((t) => String(t._id) === String(id));
    if (matched) return matched;
    if (row.expenseTypeId && typeof row.expenseTypeId === "object") {
      return row.expenseTypeId;
    }
  }
  if (row?.type != null) {
    const legacyName = LEGACY_TYPE_LABELS[Number(row.type)];
    if (legacyName) {
      return types.find((t) => t.name === legacyName) || "";
    }
  }
  return "";
};
